import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import Popup from '../Popup/Popup'
import { useTranslation } from 'react-i18next'
import { BrandedLinkButton, PrimaryButton, SecondaryButton } from '../../common/Buttons'
import { CustomPopup } from '../../common/Popup/CustomPopup'
import CommonInput from '../../common/Resusable/CommonInput'


const SeasonalButtonGroup = ({
	updateTemplateView,
	templateView,
	templateName,
	setTemplateName,
	handleSubmit,
	handleSaveTemplate,
	templateModal,
	setTemplateModal,
	saveTempError,
	setSaveTempError,
	isModifyBooking,
	awbNo,
	setNotLeave,
	setSelectedTemplate,
	handleClearSeasonal,
	stubNose,
	breedRejected,
	isSeasonalBooking,
}) => {
	/*for multilingual*/
	const { t, i18n } = useTranslation(['labels', 'errors'])

	const history = useHistory()

	const handleCancelAction = () => {
		// handleClear()
		// history.push('/manage-template')
	}

	const handleClosePopUp = () => {
		// setTemplateModal(false)
		// setTemplateName('')
		// setSaveTempError(null)
	}

	const handleSaveTemplateClick = () => {
		//setTemplateModal(true)
	}

	const handleBackBtn = () => {
		//history.push(`/manage-booking/${awbNo}`)
	}

	const handleClearForm = (e) => {
		handleClearSeasonal()
		// setSelectedTemplate('')
		setNotLeave(false)
	}

	return (
		<div className="footer-block">
			<BrandedLinkButton onClick={handleClearForm} label={t("COMMON.CLR")} isLarge />

			{!updateTemplateView && isModifyBooking && (
				<SecondaryButton
					label={t('COMMON.BACK_BUTTON')}
					onClick={handleBackBtn}
				/>
			)}
			{!updateTemplateView && (
				<>
					<PrimaryButton
						label={t('COMMON.BACK_BUTTON')}
						onClick={(e) =>
							setSelectedTemplate('')
						}
					/>
					<SecondaryButton
						label={t('COMMON.SAVE')}
						onClick={handleSubmit}
						disabled={stubNose}
					/>
				</>
			)}
			{updateTemplateView && (
				<>
					<PrimaryButton
						label={t('MNGTMPLT.SAVE_CHANGES')}
						onClick={(e) => {
							handleSaveTemplate(false)
						}}
					/>
					<SecondaryButton
						label={t('COMMON.CANCEL')}
						onClick={handleCancelAction}
					/>
				</>
			)}
			<CustomPopup
				isVisible={templateModal}
				footerPriBtnLabel={t('COMMON.SAVE')}
				footerSecBtnLabel={t('COMMON.CANCEL')}
				headerComponent={{ mainHeader: t('SAVETMPLT.SAVE_TEMPLATE') }}
				footerPriBtnClick={(e) => {
					handleSaveTemplate(true)
				}}
				//closeErrorPopup={handleClosePopUp}
				body={
					<div className="form-group mb-3">
						<CommonInput
							label={t('SAVETMPLT.TMPLT_NAME_PLACEHOLDER')}
							type='text'
							value={templateName ? templateName : ''}
							onChange={(e) => {
								setSaveTempError(null)
								setTemplateName(e.target.value)
							}}
							error={saveTempError && saveTempError !== ''
								? t(saveTempError, { ns: 'errors' })
								: ''}
						/>
					</div>
				}
			/>
		</div>
	)
}

export default SeasonalButtonGroup
